import { Address, AdminType } from 'components/DetailsPageBoilerplate/types';
import { formatFullAddressOld } from 'utils/address';
import { CommissionTerm, FIELDS, AdminType as MappedAdminType, RADIO_VALUES } from './types';

export const formatAddress = (address: Address) => ({
  [FIELDS.POSTCODE]: address.postcode,
  [FIELDS.CITY]: address.city,
  [FIELDS.ADDRESS_LINE_1]: address.addressLine1 || '',
  [FIELDS.ADDRESS_LINE_2]: address.addressLine2 || '',
  [FIELDS.COUNTY]: address.county || '',
  [FIELDS.HOUSE_NUMBER]: address.houseNumber,
});

export const mapAdmins = (admins: AdminType[]): MappedAdminType[] => {
  return admins.map((admin) => {
    return {
      [FIELDS.ADMIN_ID]: admin.id,
      [FIELDS.ADMIN_FIRST_NAME]: admin.firstName,
      [FIELDS.ADMIN_LAST_NAME]: admin.lastName,
      [FIELDS.ADMIN_NAME]: `${admin.firstName} ${admin.lastName}`,
      [FIELDS.ADMIN_FCA]: admin.fcaNumber,
      [FIELDS.ADMIN_ADDRESS]: formatAddress(admin.address),
      [FIELDS.ADMIN_FULL_ADDRESS]: formatFullAddressOld(admin.address),
      [FIELDS.ADMIN_EMAIL]: admin.email,
      [FIELDS.ADMIN_PHONE]: admin.phone,
      [FIELDS.ADMIN_LMC_STATUS]: admin.isLMCActive ? RADIO_VALUES.ACTIVE : RADIO_VALUES.INACTIVE,
    };
  });
};

export const createBody = (fieldName: string, values: any) => {
  const body =
    fieldName === 'address'
      ? {
          street_line_1: values.addressLine1,
          street_line_2: values.addressLine2,
          city: values.city,
          county: values.county,
          house_number: values.houseNumber,
          post_code: values.postcode,
        }
        : { [fieldName]: values };

  return body;
};

export const produceNewTerm = () => '';

export const filterCommissionTermsByType = (commissionTerms: any, type: string) => {
  return commissionTerms.filter((commissionTerm: CommissionTerm) => commissionTerm.type === type);
};
